import * as React from 'react';

function SvgPayoutSettlementSync(props) {
  return (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.393 5.896A4.597 4.597 0 012.74 2.743a4.584 4.584 0 013.258-1.35 4.572 4.572 0 013.256 1.35c.133.132.258.273.373.42l-.806.63a.107.107 0 00.04.189l2.353.576a.108.108 0 00.133-.104l.01-2.422c0-.09-.103-.14-.173-.085l-.755.59A5.624 5.624 0 00.375 5.89a.107.107 0 00.107.111h.804a.107.107 0 00.107-.104zM11.518 6h-.804a.107.107 0 00-.107.104A4.576 4.576 0 019.26 9.257 4.586 4.586 0 016 10.607a4.582 4.582 0 01-3.63-1.77l.807-.63a.107.107 0 00-.04-.189L.785 7.442a.108.108 0 00-.133.104L.642 9.97c0 .09.104.14.174.084l.755-.59A5.624 5.624 0 0011.625 6.11a.107.107 0 00-.107-.11z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgPayoutSettlementSync;
